<template>
  <section>
    <div class="max-w-6xl mx-auto px-4 sm:px-6">
      <div class="py-12 md:py-20 border-t border-gray-200 lg:border-0 lg:pt-0">
        <!-- Section header -->
        <div class="max-w-3xl mx-auto text-center pb-12 md:pb-20">
          <h2 class="h2 mb-4">サービス紹介</h2>
          <p class="text-xl text-gray-600">
            デトックスプログラムには、下記の内容が含まれます。
          </p>
        </div>

        <!-- Items -->
        <div
          class="max-w-sm mx-auto grid gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-16 items-start md:max-w-2xl lg:max-w-none"
          data-aos-id-blocks
        >
          <!-- 1st item -->
          <div class="relative flex flex-col items-center" data-aos="fade-up" data-aos-anchor="[data-aos-id-blocks]">
            <h4 class="h4 mb-2">ハーブ製品を提供</h4>
            <p class="text-lg text-gray-600 text-center">100%天然由来成分のハーブ製品を利用しています。</p>
          </div>

          <!-- 2nd item -->
          <div
            class="relative flex flex-col items-center"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-anchor="[data-aos-id-blocks]"
          >
            <h4 class="h4 mb-2">食事指導</h4>
            <p class="text-lg text-gray-600 text-center">
              デトックスプログラムを作成し、それに合わせて食事指導を行います。
            </p>
          </div>

          <!-- 3rd item -->
          <div
            class="relative flex flex-col items-center"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-anchor="[data-aos-id-blocks]"
          >
            <h4 class="h4 mb-2">生活習慣指導</h4>
            <p class="text-lg text-gray-600 text-center">
              運動や普段の行動、業務環境など、ヒアリングをしながら生活習慣にアドバイスをさせていただきます。
            </p>
          </div>

          <!-- 4th item -->
          <div
            class="relative flex flex-col items-center"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-anchor="[data-aos-id-blocks]"
          >
            <h4 class="h4 mb-2">エクササイズ指導</h4>
            <p class="text-lg text-gray-600 text-center">
              ご希望の場合、デトックスに効果的なエクササイズ指導も可能です。
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FeaturesDetox",
}
</script>
